var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 27,
    viewBox: "0 0 29 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 29,
    height: 27,
    rx: 13.5,
    fill: "#0094FF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_823_14921)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.229 11.2349V12.4868C15.2849 12.4499 15.3145 12.4404 15.3274 12.4202C15.7694 11.726 16.4398 11.399 17.2221 11.2764C18.1474 11.1302 19.066 11.1644 19.9315 11.5681C20.7037 11.927 21.1333 12.5759 21.2814 13.3838C21.4066 14.0754 21.4748 14.7761 21.4853 15.4789C21.5144 17.0852 21.4948 18.6921 21.4943 20.299C21.4943 20.3634 21.487 20.4277 21.482 20.5H18.7944C18.7944 20.4014 18.7944 20.3152 18.7944 20.229C18.7944 18.7173 18.8067 17.2056 18.7793 15.6939C18.7637 15.2711 18.6894 14.8526 18.5586 14.4504C18.3843 13.8832 17.9535 13.5865 17.3618 13.5445C17.1722 13.5298 16.9815 13.5351 16.793 13.5602C16.1018 13.6609 15.6889 14.087 15.5459 14.7482C15.458 15.1719 15.4126 15.6033 15.4101 16.036C15.3939 17.4357 15.4039 18.8388 15.4039 20.2402V20.4972H12.7393V11.2349H15.229Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.56641 11.2227H10.7513V20.4972H7.56641V11.2227Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.13378 6.5C9.56661 6.50081 9.98186 6.67167 10.2904 6.97588C10.5989 7.28009 10.776 7.69339 10.7838 8.12703C10.7927 9.00998 10.054 9.76471 9.15837 9.78822C8.27275 9.81118 7.5 9.04805 7.5 8.14551C7.50347 7.71162 7.67645 7.29636 7.98186 6.98876C8.28727 6.68115 8.70079 6.5057 9.13378 6.5Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_823_14921"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(7.5 6.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.6256fafa0e0684aee429e7c92d866097.svg";
export { ForwardRef as ReactComponent };